import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import StartTheConversation from "./sections/StartTheConversation";
import ConsultationInquiry from "./sections/ConsultationInquiry";
import GlobalReach from "./sections/GlobalReach";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <StartTheConversation />
      <ConsultationInquiry />
      <GlobalReach />
      <Footer />
    </div>;
}